import { gql } from "graphql-request";

export const configurations = {
  configurations: gql`
    query Configurations {
      configurations {
        tenantId
        featureFlags {
          enabled
          flag
          description
          isTargeted
          expectedRelease
          teamOwnership
          jiraNumber
          createdDate
        }
      }
    }
  `,
};
